const STATUS_SURVEY = {
  DOING: 'doing',
  DONE: 'done',
  SKIPPED: 'skipped',
};

const SURVEY_TYPE = {
  SIGNUP: 'signup',
  EDUCATOR: 'educator',
};

const SURVEY_DISPLAY_TYPE = {
  DROPDOWN: 'dropdown',
  CARD: 'card',
};

export { STATUS_SURVEY, SURVEY_TYPE, SURVEY_DISPLAY_TYPE };
